export function calculatePercent(value: number, total: number): number {
  if (value === 0) {
    return 0;
  }
  if (total === 0) {
    throw new Error("Total must be greater than zero");
  }
  if ((value / total) * 100 < 1) {
    return 1;
  }
  return Math.round((value / total) * 100);
}
